/*
 * Jira Ticket:
 * Created Date: Mon, 8th Jun 2020, 15:38:21 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';
import { getListRoles } from 'DataProvider/queries';

export const createOrganisationMutation = gql`
  mutation createOrganisation(
    $name: String!
    $contact: OrganisationContactInput!
    $checklistRequired: Boolean
    $projectAccess: Boolean!
    $addressLine1: String!
    $addressLine2: String
    $city: String!
    $postCode: String!
    $country: String!
  ) {
    data: createOrganisation(
      name: $name
      contact: $contact
      checklistRequired: $checklistRequired
      projectAccess: $projectAccess
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      city: $city
      postCode: $postCode
      country: $country
    ) {
      id
      name
      statistics {
        numberOfProjects
        numberOfSites
        numberOfUsers
      }
      contact {
        name
        email
        phone
        position
      }
      subscription {
        subscriptionTier {
          id
          capabilities {
            id
            enabled
          }
        }
      }
      checklistRequired
      projectAccess
      role
      addressLine1
      addressLine2
      city
      postCode
      country
    }
  }
`;

export default async ({ client, params }) => {
  try {
    const result = await client.mutate({
      mutation: createOrganisationMutation,
      variables: {
        ...params.data,
      },
    });
    await getListRoles({ client, params });
    return result;
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
